import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MotivoCualitativoForm from "./MotivoCualitativoForm";
import { getData, pathData } from "../../Utils/Http/api";

const MotivoCualitativoEdit = () => {
  const { id } = useParams();
  const [valores, setValores] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getData(`/MotivoCualitativoGet/${id}`);
        setValores({ descripcion: res.value.descripcion, activo: !!res.value.activo });
      } catch (ex) {
        console.error("Error cargando Motivo Cualitativo:", ex);
      }
    };
    fetchData();
  }, [id]);

  // El formulario toma los valores iniciales una sola vez: se monta cuando el motivo ya llegó.
  if (!valores) return null;

  return (
    <MotivoCualitativoForm
      titulo="Editar Motivo de Campaña Cualitativa"
      descripcion="Modifica el motivo seleccionado o desactivalo para que no se ofrezca en nuevas importaciones."
      valoresIniciales={valores}
      onGuardar={(datos) => pathData("/MotivoCualitativoUpdate", { idMotivoCualitativo: Number(id), ...datos })}
      mensajeExito="¡Motivo actualizado exitosamente!"
    />
  );
};

export default MotivoCualitativoEdit;
